import { render, staticRenderFns } from "./UserProfileCommentItem.vue?vue&type=template&id=27f076a4&scoped=true&"
import script from "./UserProfileCommentItem.vue?vue&type=script&lang=js&"
export * from "./UserProfileCommentItem.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCommentItem.vue?vue&type=style&index=0&id=27f076a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f076a4",
  null
  
)

export default component.exports